var puzzle = [];
puzzle[0] = [0, 0, 21, 0, 0];
puzzle[1] = [21, 21, 0, 21, 21];
puzzle[2] = [10, 27, 27, 27, 10];
puzzle[3] = [0, 27, 0, 17, 27];
puzzle[4] = [15, 23, 23, 24, 27];
puzzle[5] = [0, 0, 21, 21, 14];
puzzle[6] = [15, 17, 17, 17, 15];
puzzle[7] = [0, 4, 10, 21, 10];
puzzle[8] = [10, 31, 14, 26, 7];
puzzle[9] = [14, 14, 14, 0, 0];
puzzle[10] = [21, 21, 21, 21, 14];
puzzle[11] = [31, 10, 27, 14, 10];
puzzle[12] = [8, 20, 10, 5, 2];
puzzle[13] = [0, 0, 2, 2, 2];
puzzle[14] = [0, 2, 0, 2, 0];
puzzle[15] = [1, 1, 1, 1, 31];
puzzle[16] = [0, 0, 4, 14, 31];
puzzle[17] = [4, 10, 21, 10, 4];
puzzle[18] = [21, 0, 21, 0, 21];
puzzle[19] = [0, 0, 17, 0, 0];
puzzle[20] = [30, 2, 14, 2, 2];
puzzle[21] = [14, 17, 17, 17, 14];
puzzle[22] = [0, 0, 28, 12, 4];
puzzle[23] = [0, 0, 17, 31, 18];
puzzle[24] = [1, 3, 7, 15, 30];
puzzle[25] = [17, 17, 31, 17, 17];
puzzle[26] = [4, 14, 4, 4, 4];
puzzle[27] = [0, 0, 28, 28, 28];
puzzle[28] = [0, 2, 0, 0, 0];
puzzle[29] = [0, 0, 4, 0, 0];
puzzle[30] = [17, 19, 21, 25, 17];
puzzle[31] = [31, 8, 4, 2, 31];
puzzle[32] = [8, 8, 21, 17, 25];
puzzle[33] = [20, 17, 17, 22, 30];
puzzle[34] = [24, 10, 17, 21, 0];
puzzle[35] = [4, 10, 17, 31, 17];
puzzle[36] = [0, 14, 14, 14, 0];
puzzle[37] = [21, 10, 21, 10, 21];
puzzle[38] = [10, 1, 3, 12, 10];
puzzle[39] = [0, 0, 10, 0, 0];
puzzle[40] = [17, 10, 4, 4, 4];
puzzle[41] = [7, 9, 7, 9, 7];
puzzle[42] = [17, 11, 7, 2, 14];
puzzle[43] = [0, 27, 31, 4, 14];
puzzle[44] = [14, 5, 28, 15, 21];
puzzle[45] = [4, 14, 31, 14, 4];
puzzle[46] = [4, 31, 5, 18, 16];
puzzle[47] = [0, 17, 4, 17, 0];
puzzle[48] = [17, 10, 4, 10, 17];
puzzle[49] = [31, 31, 31, 31, 31];
puzzle[50] = [27, 0, 27, 0, 27];
puzzle[51] = [31, 4, 0, 4, 31];
puzzle[52] = [31, 10, 4, 10, 31];
puzzle[53] = [10, 17, 0, 27, 17];
puzzle[54] = [4, 6, 27, 12, 4];
puzzle[55] = [10, 31, 21, 31, 10];
puzzle[56] = [21, 17, 27, 17, 21];
puzzle[57] = [0, 0, 14, 2, 0];
puzzle[58] = [16, 8, 4, 6, 5];
puzzle[59] = [0, 21, 17, 21, 17];
puzzle[60] = [31, 14, 14, 14, 31];
puzzle[61] = [17, 10, 0, 10, 17];
puzzle[62] = [14, 10, 14, 8, 14];
puzzle[63] = [15, 9, 15, 7, 9];
puzzle[64] = [21, 21, 21, 21, 14];
puzzle[65] = [14, 2, 14, 8, 14];
puzzle[66] = [31, 17, 21, 17, 31];
puzzle[67] = [21, 0, 21, 0, 21];
puzzle[68] = [10, 21, 14, 21, 10];
puzzle[69] = [21, 0, 0, 0, 21];
puzzle[70] = [31, 29, 27, 23, 31];
puzzle[71] = [31, 4, 31, 17, 17];
puzzle[72] = [27, 10, 27, 10, 27];
puzzle[73] = [4, 10, 31, 17, 31];
puzzle[74] = [17, 27, 21, 17, 17];
puzzle[75] = [31, 21, 31, 21, 31];
puzzle[76] = [14, 4, 4, 4, 14];
puzzle[77] = [14, 10, 31, 14, 27];
puzzle[78] = [0, 0, 4, 0, 0];
puzzle[79] = [17, 0, 4, 0, 17];
puzzle[80] = [27, 27, 0, 27, 27];
puzzle[81] = [10, 0, 17, 14, 4];
puzzle[82] = [21, 14, 27, 14, 21];
puzzle[83] = [17, 19, 21, 25, 17];
puzzle[84] = [21, 21, 27, 21, 21];
puzzle[85] = [4, 4, 14, 21, 21];
puzzle[86] = [21, 21, 21, 21, 31];
puzzle[87] = [0, 14, 14, 14, 0];
puzzle[88] = [4, 10, 17, 31, 17];
puzzle[89] = [21, 10, 21, 10, 21];
puzzle[90] = [17, 14, 10, 14, 17];
puzzle[91] = [4, 10, 17, 10, 4];
puzzle[92] = [21, 0, 10, 0, 21];
puzzle[93] = [10, 31, 10, 31, 10];
puzzle[94] = [31, 21, 31, 29, 31];
puzzle[95] = [17, 10, 4, 10, 17];
puzzle[96] = [31, 4, 31, 4, 31];
puzzle[97] = [31, 14, 4, 14, 31];
puzzle[98] = [4, 21, 31, 21, 4];
puzzle[99] = [31, 31, 31, 31, 31];

var posit = [];

function init() {
  var p = getRandomPuzzleIndex();

  for (var i = 0; i <= 4; i++) {
    posit[i] = 2 * puzzle[p][i];
  }
  return setBoard();
}
function setBoard() {
  var board = [];
  for (var i = 0; i <= 4; i++) {
    board[i] = [];
    var k = 2;
    for (var j = 0; j <= 4; j++) {
      var c = 0;
      if (posit[i] & k) c = 1;
      c += 4;

      board[i][j] = c === 4 ? false : true;
      k += k;
    }
  }
  return board;
}

function getRandomPuzzleIndex() {
  //puzz has a 100 indices, from 0 to 99
  return Math.round(Math.random() * 99);
}

export default init;
